<template>

  <div class="sticky">
    <PageLoader/>
    <Navigation />


    <section class="sms__pro section__container spacer-2">
      <div class="slider">
      <slick
      ref="slick"
  :options="slickOptions"
  
  >
  <div>
    <h2 class="slide__header">Bénéficiez d'une plateforme en ligne polyvalente à 100% </h2>
    <p class="slide__description">
      Centralisez et envoyez toutes vos campagnes de marketing direct à partir de servicesms.sn 
      : SMS PRO, SMS Vocal, Sondage SMS, Vote SMS, Location BDD, et plus encore.
    </p>
    <a class="btn" href="https://back.servicesms.sn/login" target="_blank">ESSAYER MAINTENANT </a>
  </div>
  <div>
    <h2  class="slide__header">
  
      Envoyez des SMS en grand nombre </h2>
    <p class="slide__description">
      Communiquez avec vos clients dans le monde entier. Intégrez les SMS à votre stratégie marketing et explorez 
      la puissance du canal SMS pour votre entreprise.
    </p>
    <a class="btn" href="https://back.servicesms.sn/login">ESSAYER MAINTENANT </a>
  </div>

  <div>
    <h2  class="slide__header">Louez des fichiers ciblés et géolocalisés </h2>
    <p class="slide__description">
      Augmentez votre part de marché, maximisez votre retour sur investissement (ROI), 
      atteignez de nouveaux publics. À partir de 85F HT/contact, incluant la location et le routage.
    </p>
    <a class="btn" href="https://back.servicesms.sn/login">ESSAYER MAINTENANT </a>
  </div>
</slick>
</div>
      <div class="phone">
        <img
          class="img"
          src="/../images/bienvenue-sms.png"
          alt="services"
        />
      </div>
    </section>

    <section class="services section__container">
      <h1 class="services__title center__text ">
        UN PANEL COMPLET DE SOLUTIONS
      </h1>
      <div class="services__cards">
        <div class="services__card spacer-1">
          <img class="card__image" src="/../images/icon-sms-pro.png" alt="smspro" />
          <div class="card__details">
            
            <router-link to="/smspro" class="card__title">SMS PRO</router-link>
            <p class="card__description center__text">
              Optimal pour vos comm. campagnes : personnalisation du nom émetteur,
              accusé de réception inclus. À partir de 28,24F/SMS. Profitez-en !
            </p>
          </div>
        </div>

        <div class="services__card spacer-1">
          <img class="card__image" src="/../images/icone-vocal-sms.png" alt="smsvocal" />
          <div class="card__details">
         
            <router-link to="/smsvocal"  class="card__title sms__vocal">SMS VOCAL</router-link>
            <p class="card__description center__text">
              Facilitez la vie de vos clients avec des rappels ou confirmations de rendez-vous
              par messages vocaux sur ligne fixe ou mobile.
            </p>
          </div>
        </div>

        <div class="services__card spacer-1">
          <img class="card__image" src="/../images/icone-sms-20.png" alt="sms" />
          <div class="card__details">
         
            <router-link to="/enrich" class="card__title">SMS ENRICHI</router-link>
            <p class="card__description center__text">
              Besoin d'interaction client ? Le SMS enrichi permet coupons,
              questionnaires, et exploration de pages produit en ligne. Intéressé ?
            </p>
          </div>
        </div>
        <div class="services__card spacer-1">
          <img class="card__image" src="/../images/loca-bdd-sms.png" alt="bdd" />
          <div class="card__details">
           
            <router-link to="/location" class="card__title">LOCATION BDD </router-link>
            <p class="card__description center__text">
              Bénéficiez de notre soutien : location de fichiers ciblés et géolocalisés
              pour optimiser l'efficacité de vos campagnes marketing.
          
            </p>
            
            
          
          </div>
        </div>


        <div class="services__card spacer-1">
          <img class="card__image" src="/../images/emailing-icon-.png" alt="smsmailing" />
          <div class="card__details">
          
            <router-link to="/mailing" class="card__title">MAIL TO SMS</router-link>
            <p class="card__description center__text">
              Choisissez ce canal pour vos campagnes marketing et touchez rapidement
              votre cible avec des messages brefs et percutants, pour un impact assuré.
            </p>
          </div>
        </div>

        <div class="services__card spacer-1">
          <img class="card__image" src="/../images/sondage-par-sms.png" alt="sms" />
          <div class="card__details">
       
            <router-link to="/sondage" class="card__title">SONDAGES SMS</router-link>
            <p class="card__description center__text">
              Centrez vos enquêtes de satisfaction sur la clientèle pour renforcer
              la fidélisation. Des SMS interactifs recueillent leurs avis et améliorent votre offre.
            </p>
          </div>
        </div>

        <div class="services__card spacer-1">
          <img class="card__image" src="/../images/vote-par-sms.png" alt="vote" />
          <div class="card__details">
           
            <router-link to="/votre" class="card__title">VOTE SMS</router-link>
            <p class="card__description center__text">
              Votez par SMS lors AG, congrès, réunions, élections, concours, salons.
              Plateforme vote en ligne par SMS pour événements mémorables.
              
            </p>
          </div>
        </div>

     
        <div class="services__card spacer-1">
          <img class="card__image" src="/../images/mobile-Tiketing.png" alt="ticketing" />
          <div class="card__details">
      
            <router-link to="/mobileticketing" class="card__title">MOBILE TICKETING</router-link>
            <p class="card__description center__text">
              Obtenez "E-TICKET" via appli billetterie. Achetez vos tickets de bus partout au Sénégal, 
              depuis chez vous, en toute simplicité.
              
              
            </p>
          </div>
        </div>
        
      </div>
    </section>

    <section class="revolution spacer-1">
     
       
        <div >
          <Reference/>
        </div>


        
    
    </section>
    
    <Footer />
  </div>
</template>

<script>
import Vue from 'vue'
import Navigation from "./Navigation";
import Footer from "./Footer";
import Slick from 'vue-slick';   
import PageLoader from './PageLoader';
import Reference from './Reference';
import 'slick-carousel/slick/slick.css';








export default {
  data() {
    return {
      isLoading:false,
      fullPage:true,
      hover: false,
      slickOptions: {     
         autoplay:true,
         arrows:false,
         autoplaySpeed:3900

        
               
            },
    };
  },
  components: {
    Navigation,
    Footer,
    Slick,
    PageLoader,
    Reference
   
   
  },
  methods:{
    next() {
            this.$refs.slick.next();
        },

        prev() {
            this.$refs.slick.prev();
        },
        reInit() {
            // Helpful if you have to deal with v-for to update dynamic lists
            this.$nextTick(() => {
                this.$refs.slick.reSlick();
            });
        },
        handleAfterChange(event, slick, currentSlide) {
            console.log('handleAfterChange', event, slick, currentSlide);
        },
        handleBeforeChange(event, slick, currentSlide, nextSlide) {
            console.log('handleBeforeChange', event, slick, currentSlide, nextSlide);
        },
        handleBreakpoint(event, slick, breakpoint) {
            console.log('handleBreakpoint', event, slick, breakpoint);
        },
        handleDestroy(event, slick) {
            console.log('handleDestroy', event, slick);
        },
        handleEdge(event, slick, direction) {
            console.log('handleEdge', event, slick, direction);
        },
        handleInit(event, slick) {
            console.log('handleInit', event, slick);
        },
        handleReInit(event, slick) {
            console.log('handleReInit', event, slick);
        },
        handleSetPosition(event, slick) {
            console.log('handleSetPosition', event, slick);
        },
        handleSwipe(event, slick, direction) {
            console.log('handleSwipe', event, slick, direction);
        },
        handleLazyLoaded(event, slick, image, imageSource) {
            console.log('handleLazyLoaded', event, slick, image, imageSource);
        },
        handleLazyLoadError(event, slick, image, imageSource) {
            console.log('handleLazeLoadError', event, slick, image, imageSource);
        },

        
    
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/base.scss";

.solution {
  font-weight: bold;
}

.spacer-2{
  margin-top: -2rem;
}



.btn{
  margin-left:1rem;
}
.sticky{
  position: sticky;
}
.services__cards{
  background-color: white;
    border-radius: 0.25rem;
    // box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
    padding: 2rem;
}
.services__card{
  background-color: white;
    border-radius: 0.25rem;
    box-shadow: 0 20px 40px -14px rgba(0, 0, 0, 0.25);
     transition: transform .3s;

  &:hover{
    transform: scale(1.1); 
  }
}
.center__button {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card__image {
  display: block;
  margin: 0 auto;
}
.card__title {
  text-align: center;
  font-weight: bold;
  display: block;
  text-decoration: none;
  color: $color-black;
}


.card__description {
  height: 170px;
  overflow: hidden;
}

.card__details{
  padding: 1rem;
}
.img{
  max-width: 100%;
  display: block;
  margin: 0 auto;
}
.service__title{
  text-align: center;
}
.sms__pro{
  box-shadow: 0 20px 40px -14px rgb(0 0 0 / 25%);
}
.slide__header{
  padding: 1rem;
}

.slide__description{
  padding: 1rem;
}
@media (min-width: 64rem) {
  .sms__pro {
    display: grid;
    grid-template-columns: 1fr 1fr;
    background: #fafafa;
   
    margin-top: 7rem;
  
  }

  .slider{
  
    width:30rem;
    height:auto;
    padding: 1rem;
  }

  .slide__header{
    font-weight: bold;
  
  }
  .sms__description {
    font-weight: bold;
    font-size: 1.5rem;
  }
 .center__button{
   display: block;
 }
  .home__title {
    font-size: 3rem;
    color: $color-tertiary;
  }

  .services__cards {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    grid-gap: 2rem;
  }

  .card__title {
    text-align: center;
    border-bottom: 2px solid $color-tertiary;
  }

  .card__image {
   
    padding: 1rem;
  
  }
  

 
  
  .service__title {
    text-align: left;
    padding: 2rem;
  }
 
}
</style>